import Sprite = PIXI.Sprite;
import Container = PIXI.Container;
import Text = PIXI.Text;
import { createSprite } from '../../../utils/GameEngine';
import { clearAnimations } from '../../../utils/Animations';
import { CurrencyName, ResourceName } from '../../../core/managers/Inventory';
import { RewardItem } from '../../../core/reward/Reward';
import { TextStyles } from '../../../utils/TextStyles';

interface ItemTextures {
    iconTexture: string;
    bgTexture: string;
}

export class RewardPanel extends Container {
    private bg: PIXI.Sprite;

    constructor(reward: RewardItem) {
        super();
        const textures: ItemTextures = this.getIconTexture(reward.resourceName);

        this.bg = createSprite(textures.bgTexture, this);
        this.bg.anchor.set(0.5, 0.5);
        this.bg.scale.set(1.5, 1.5);
        TweenLite.to(this.bg, 600, {
            rotation: 100
        });

        const icon: Sprite = createSprite(textures.iconTexture, this);
        icon.anchor.set(0.5, 0.5);
        icon.scale.set(0.8, 0.8);

        const amount: Text = new Text('+' + reward.amount, TextStyles.uiText);
        amount.anchor.set(0.5, 0.5);
        amount.x = this.bg.x;
        amount.y = this.bg.y + this.bg.height / 2 + amount.height / 2;
        this.addChild(amount);
    }

    private getIconTexture(itemName: CurrencyName | ResourceName): ItemTextures {
        const textureNames: ItemTextures = {
            iconTexture: '',
            bgTexture: ''
        };
        switch (itemName) {
            case CurrencyName.Coins: {
                textureNames.iconTexture = 'coin_icon@2x';
                textureNames.bgTexture = 'third_booster_bg';
                break;
            }
            case ResourceName.Lives: {
                textureNames.iconTexture = 'heart_icon@2x';
                textureNames.bgTexture = 'hint_booster_bg';
                break;
            }
        }
        return textureNames;
    }

    public destroy(options?: { children?: boolean; texture?: boolean; baseTexture?: boolean }): void {
        clearAnimations(this.bg);
        super.destroy(options);
    }
}